import { SupportAgent as SupportAgentIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';

import { appRoutes } from '@clearverify/constants';

import { NavListItem } from 'src/components/common';
import { useScreenInfo } from 'src/hooks/common';
import { useGlobalState } from 'src/hooks/shared';

import { navListItemStyles } from './styles';

export const ResourcesListItem = () => {
  const { isMobile } = useScreenInfo();
  const { leftMenuDrawerState } = useGlobalState();

  return (
    <NavListItem
      link={appRoutes.resources.index}
      onClick={() => (isMobile ? leftMenuDrawerState?.close() : null)}
      startIcon={<NavListItem.Icon icon={SupportAgentIcon} />}
      listItemText={
        leftMenuDrawerState.isOpened && (
          <NavListItem.Text sx={{ flex: '1 1 auto', my: 0.5, ml: 4 }}>
            <Typography variant="body1">Resources & Help</Typography>
          </NavListItem.Text>
        )
      }
      sx={navListItemStyles}
    />
  );
};
